import { Chip, Typography } from '@mui/material';

const RecommendedTag = ({ content }) => {
    return (
        <Chip
            className="pricingRecommendedChip"
            label={<Typography className={'pricing-recommendedTag fw-500'}>{content || 'Recommended'}</Typography>}
        ></Chip>
    );
};
export default RecommendedTag;
